<template>
    <div v-if="widgetReady">
        <div class="row">
            <div class="col-md-12">
                <h4>{{partyName}}</h4>
                <p>Specify who will {{isPayer ? "remit" : "receive"}} payment</p>
            </div>
            <div class="col-md-6 form-group">
                <label>{{partyName}} Name</label>
                <small><span class="redText">required</span></small>
                <input type="text" class="form-control" :placeholder="partyName + ' Name'" v-model="vm.name">
            </div>
            <div class="col-md-6 form-group">
                <label>{{partyName}} Email</label>
                <input type="text" class="form-control" :placeholder="partyName + ' Email'" v-model="vm.email">
            </div>
        </div>
        <ac-banking-info :can-save="false" :show-required="true" :save-banking-info="()=>{}" v-model="vm.bankingInfo">
            
        </ac-banking-info>
    </div>
</template>

<script>
    import {api} from "../../../global/framework/api.js";

    export default {
        name: "PayeeForm",
        props: {
            isPayer: {type: [Boolean], default: false},
        },
        data() {
            return {
                widgetReady: false,
                vm: {}
            }
        },
        computed: {
            partyName() {
                return this.isPayer ? 'Payer' : 'Payee';
            }
        },
        async mounted() {
            let template = await api.getNoId('Fee', 'GetExternalPayeeTemplate');
            this.mapData('vm', template);
            this.widgetReady = true;
        },
        methods: {
            async getPayee() {
                let validation = await api.post('Fee', 'ValidatePayee', this.vm, true);
                if (validation) {
                    return this.vm;
                }
                return null;
            }
        }
    }
</script>

<style scoped>

</style>